document.addEventListener("DOMContentLoaded", function () {
    const sizeDetails = {
  "us2": {'cm':{'b':'83','w':'65','h':'91','len':'150'},'in':{'b':'32 ½','w':'25 ½','h':'35 ¾','len':'59'}},
  "us4": {'cm':{'b':'85','w':'68','h':'93','len':'150'},'in':{'b':'33 ½','w':'26 ½','h':'36 ¾','len':'59'}},
  "us6": {'cm':{'b':'88','w':'70','h':'96','len':'152'},'in':{'b':'34 ½','w':'27 ½','h':'37 ¾','len':'60'}},
  "us8": {'cm':{'b':'90','w':'72','h':'98','len':'152'},'in':{'b':'35 ½','w':'28 ½','h':'38 ¾','len':'60'}},
  "us10": {'cm':{'b':'93','w':'75','h':'101','len':'152'},'in':{'b':'36 ½','w':'29 ½','h':'39 ¾','len':'60'}},
  "us12": {'cm':{'b':'97','w':'79','h':'106','len':'152'},'in':{'b':'38','w':'31','h':'41 ¾','len':'60'}},
  "us14": {'cm':{'b':'100','w':'83','h':'109','len':'155'},'in':{'b':'39 ½','w':'32 ½','h':'42 ¾','len':'61'}},
  "us16": {'cm':{'b':'104','w':'86','h':'114','len':'155'},'in':{'b':'41','w':'34','h':'44 ¾','len':'61'}},
  "us18": {'cm':{'b':'114','w':'98','h':'121','len':'155'},'in':{'b':'45','w':'38 ½','h':'47 ½','len':'61'}},
  "us20": {'cm':{'b':'119','w':'104','h':'126','len':'158'},'in':{'b':'47','w':'40 ¾','h':'49 ½','len':'62'}},
  "us22": {'cm':{'b':'124','w':'109','h':'131','len':'158'},'in':{'b':'49','w':'43','h':'51 ½','len':'62'}}
};

    const optionButtons = document.querySelectorAll("input[name='Size']");

    const detailBox = document.getElementById("product-sizedetai-info");

    var defel = '';
    optionButtons.forEach(button => {
      if(button.checked)defel=button;
      
      button.addEventListener('click', () => {
        const selectedText = button.value.trim().toLowerCase();
        var detail = sizeDetails[selectedText] ;
        if(!detail){
          detail = sizeDetails['us'+selectedText];
        }
        
        if (detail) {
          var tabtxt = '<table style="width:100%;text-align: center;"><tr style="background-color:#dddddd;"><th>Size: '+selectedText.toUpperCase()+'</th><th>Bust</th><th>Waist</th><th>Hips</th><th width="25%">Hollow to Floor</th></tr><tr><td>IN</td><td>'+detail['in']['b']+'</td><td>'+detail['in']['w']+'</td><td>'+detail['in']['h']+'</td><td>'+detail['in']['len']+'</td></tr><tr><td>CM</td><td>'+detail['cm']['b']+'</td><td>'+detail['cm']['w']+'</td><td>'+detail['cm']['h']+'</td><td>'+detail['cm']['len']+'</td></tr></table>';
          detailBox.innerHTML = tabtxt;
          detailBox.style.display = "block";
        } else {
          detailBox.style.display = "none";
        }
      });
    });

    if(defel)defel.click();
});